define(function () {

	function getFormMarkdown(value) {
		// returns a jqXHR
		return jQuery.ajax({
			type: 'get',
		    url: MBGF.getFormAjaxUrl,
		    dataType: "json",
		    data: {
		       'action':'mb_forms_api_get_form',
		       'form_id' : value,
		    },
		    success: function(form){
		    	renderMarkdown(form);
		    },
		    error: function(errorThrown){
		    	console.log(errorThrown);
		    }
		});
	}

	function renderMarkdown(form) {
		var html = '';
		html += '<div id="render-container" data-formid="'+form.form_id+'">';
		html +=		'<script type="text" id="campaign-markdown">';
		html += 		form.markdown;
		html += 	'</script>';
		html += '</div>';
		jQuery('#form-container').html(html);
	}

	return {
		getFormMarkdown: getFormMarkdown
	};

});




// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/markdown-handler.js